/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-05-21 16:02:42
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-07-22 14:03:06
 * @FilePath: \qctsw-vue\packages\app\src\logic\news\detail.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SITE_NAME, addHost, contentAddHost, getContentImages } from '@qctsw/common'
import { contentRemoveTags, isClient } from '@qctsw/utils'
import { LOAD_STATE } from '@/shared/types'
import { getAllCarSeriesApi, getNewsDetailApi } from '@/server'
import type { NewsDetailResponse } from '@/server/types'
import { useGetRouteParam } from '@/shared/function'

export function logicNewsDetail() {
  const id = useGetRouteParam('id', '')
  const { changeMeta } = useSite()
  const { setShareBase } = useShare()

  const state = ref(LOAD_STATE.INIT)
  const detailData = ref<ReturnType<typeof format> | null>(null)

  function format(data: NewsDetailResponse) {
    return {
      ...data,
      articleContent: data.articleFormatCode === 0 ? contentAddHost(data.articleContent) : data.articleContent,
      complains: data.complains.map(item => ({
        id: item.complainId,
        title: item.complainTitle,
      })),
      collectives: data.collectives.map(item => ({
        id: item.collectiveId,
        title: item.collectiveTitle,
      })),
    }
  }

  async function getDetail(id: string) {
    const res = await useLoadState({
      key: `文章详情-${id}`,
      state,
      fn: () => getNewsDetailApi(id),
    })

    if (!res?.data)
      return

    detailData.value = format(res?.data)

    // meta
    changeMeta({
      title: `${detailData.value.title} - ${SITE_NAME}`,
      description: contentRemoveTags(detailData.value.articleContent).slice(0, 200),
      keywords: [detailData.value.title, detailData.value?.articleSourceName, detailData.value?.authorName].filter(Boolean) as string[],
    })

    if (isClient) {
      // share
      setShareBase({
        url: window.location.href,
        title: detailData.value.title,
        content: contentRemoveTags(detailData.value.articleContent).slice(0, 200),
        images: getContentImages(detailData.value.articleContent).filter(v => !v.match(/^data:.*;base64.*/)),
      })
    }
  }

  return {
    id,
    state,
    detailData,
    getDetail,
  }
}
